export default {
  'mobileProfile.loremIpsum': 'لورم اپیسوم ',
  'mobileProfile.lastUpdated': 'اخرین به روز رسانی  ',
  'mobileProfile.next': 'بعد',
  'mobileProfile.contraryToPopular':
    'با تریپسی به زودی تمام دنیا را خواهید دید.',
  'mobileProfile.reverse': 'معکوس',
  'mobileProfile.issued': 'صادر شده ',
  'mobileProfile.search': 'جستجو کردن ',
  'mobileProfile.myFavoriteTrips': 'سفرهای مورد علاقه من ',
  'mobileProfile.newYork': 'نیویورک',
  'mobileProfile.losAngeles': 'لس آنجلس ',
  'mobileProfile.toronto': 'تورنتو',
  'mobileProfile.lookToBook': 'برای رزرو نگاه کنید ',
  'mobileProfile.grade': 'مقطع تحصیلی ',
  'mobileProfile.totalPoint': 'امتیاز کل ',
  'mobileProfile.activities': 'فعالیت ها ',
  'mobileProfile.salaryCard': 'کارت حقوق ',
  'mobileProfile.weeks': 'هفته ها ',
  'mobileProfile.searchTransaction': 'جستجوی تراکنش ',
  'mobileProfile.march': 'مارس ',
  'mobileProfile.receivedCashbook': 'دریافت دفترچه نقدی ',
  'mobileProfile.transferedMoney': 'پول منتقل شده  ',
  'mobileProfile.uber': 'اوبر',
  'mobileProfile.taxiService': 'تاکسی سرویس ',
  'mobileProfile.morimoto': 'موریموتو',
  'mobileProfile.food&Drink': 'غذا و نوشیدنی ',
  'mobileProfile.receivedMoney': 'دریافت پول',
  'mobileProfile.fromRobertFox': 'از رابرت فاکس ',
  'mobileProfile.spotifySubscr': 'زیرنویس',
  'mobileProfile.expenses': 'هزینه ها',
  'mobileProfile.subscription': 'اشتراک',
};
